import { Button } from './ui/button';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './ui/carousel';

const features = [
  {
    title: 'Welcome to Git Examples',
    description: 'Git Examples is the quick way to get better at Git.',
  },
  {
    title: 'Git by Example',
    description:
      'With more than 100 examples, you can always find a new Git secret.',
  },
  {
    title: 'Bookmark',
    description:
      'Bookmark commands to create a personalized cheatsheet that you can print.',
  },
  {
    title: 'Deep Dive',
    description:
      'Learn more about any Git command by clicking on the command name.',
  },
  {
    title: 'Mark for Review',
    description: 'Mark commands for review to revisit them later.',
  },
  {
    title: 'Take a quiz',
    description: 'Test your knowledge with a fun quiz.',
  },
];

interface FeaturesCarouselProps {
  onClose: (open: boolean) => void;
}

const FeaturesCarousel = (props: FeaturesCarouselProps) => {
  const { onClose } = props;

  return (
    <div className="overflow-hidden pb-2 sm:px-12">
      <Carousel className="w-full">
        <CarouselContent className="h-64">
          {features.map((feature) => (
            <CarouselItem key={feature.title}>
              <div className="px-4 py-8 sm:px-8">
                <h2 className="mb-4 font-bold sm:text-lg">{feature.title}</h2>
                <p className="text-sm sm:text-base">{feature.description}</p>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="relative left-0 sm:absolute sm:top-1/2 sm:-left-12 sm:-translate-y-1/2" />
        <CarouselNext className="absolute top-auto left-auto mr-12 sm:top-1/2 sm:-right-12 sm:mr-0 sm:-translate-y-1/2" />
      </Carousel>
      <div className="mt-4 flex w-full justify-center">
        <Button variant="outline" onClick={() => onClose(false)}>
          Get Started
        </Button>
      </div>
    </div>
  );
};

export default FeaturesCarousel;
